import { Resource } from './Resource.js';
import { getDistance } from '../utils/math.js';
import { AI_CONFIG, ANIMATION_CONFIG, COMBAT_CONFIG } from '../config.js';
import { audioManager } from '../systems/AudioManager.js';

export class Corpse extends Resource {
  constructor(x, y, originalTeam = null, originalLevel = 1) {
    super(x, y, 1);
    
    // Corpse-specific properties
    this.createdAt = Date.now();
    this.originalTeam = originalTeam;
    this.originalLevel = originalLevel;
    this.opacity = 1.0;
  }
  
  // Update corpse decay
  updateSpecific(delta) {
    const age = Date.now() - this.createdAt;
    if (age > AI_CONFIG.CORPSE_DECAY_TIME) {
      // Fade out over last 5 seconds
      const fadeTime = ANIMATION_CONFIG.CORPSE_FADE_TIME;
      const timeLeft = AI_CONFIG.CORPSE_DECAY_TIME + fadeTime - age;
      if (timeLeft <= 0) {
        this.active = false;
      } else {
        this.opacity = timeLeft / fadeTime;
      }
    }
  }
  
  // Corpses can be collected by any unit
  canBeCollectedBy(soldier) {
    if (this.isBeingCollected) return false;
    const distance = getDistance(this, soldier);
    return distance <= AI_CONFIG.CORPSE_COLLECTION_RADIUS;
  }
  
  // Collecting a corpse gives level-up and ammo
  collect(collector) {
    collector.levelUp();
    audioManager.playLevelUp();
    
    // Full ammo refill PLUS bonus ammo
    const bonusAmmo = Math.min(COMBAT_CONFIG.CORPSE_AMMO_GRANTED, collector.maxAmmo);
    collector.ammo = Math.min(collector.maxAmmo + bonusAmmo, collector.maxAmmo);
    
    return { type: 'corpse', amount: 1 };
  }
  
  // Render as X mark
  renderSpecific(ctx, pulse) {
    // Apply corpse opacity
    ctx.globalAlpha *= this.opacity;
    
    ctx.strokeStyle = '#ccc';
    ctx.lineWidth = 1;
    
    const size = 3 * this.scale;
    
    // Draw X mark (relative to animated position)
    ctx.beginPath();
    ctx.moveTo(-size, -size);
    ctx.lineTo(size, size);
    ctx.moveTo(size, -size);
    ctx.lineTo(-size, size);
    ctx.stroke();
    
    // Draw pulsing effect for visibility
    if (pulse > 0.5 && !this.isBeingCollected) {
      ctx.globalAlpha *= 0.3;
      ctx.strokeStyle = '#fff';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(-size, -size);
      ctx.lineTo(size, size);
      ctx.moveTo(size, -size);
      ctx.lineTo(-size, size);
      ctx.stroke();
    }
  }
}